<template>
  <div class="staff-management">
    <h1 class="text-h1 neutral-041--text">
      {{ $t('STAFF_MANAGEMENT.TITLE') }}
    </h1>
    <div class="mt-5 d-flex">
      <!-- 上傳班表 -->
      <div class="upload-staff-schedule">
        <UploadStaffSchedule
          @reload-schedule-report="reloadScheduleReport"
        />
      </div>
      <!-- 班表 DataTable -->
      <div class="staff-schedule-report">
        <StaffScheduleReport
          ref="staffScheduleReport"
        />
      </div>
    </div>
    <div class="mt-10 d-flex">
      <!-- 下班時段自動回覆 -->
      <div class="offline-auto-reply">
        <OfflineAutoReply
          :is-admin-or-manager="isAdminOrManager"
        />
      </div>
      <!-- 店員離線訊息設定 -->
      <div
        v-if="isAdminOrManager"
        class="staff-messaging-setting"
      >
        <StaffMessagingSetting />
      </div>
    </div>
    <Notification
      ref="notification"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ROLE } from '@/utils/constants';
import UploadStaffSchedule from './components/UploadStaffSchedule.vue';
import StaffScheduleReport from './components/StaffScheduleReport.vue';
import OfflineAutoReply from './components/OfflineAutoReply.vue';
import StaffMessagingSetting from './components/StaffMessagingSetting.vue';

export default {
  name: 'StaffManagement',
  metaInfo: {
    title: 'Staff Management - Omnichat Admin Panel'
  },
  components: {
    UploadStaffSchedule,
    StaffScheduleReport,
    OfflineAutoReply,
    StaffMessagingSetting
  },
  data() {
    return {
      isAdminOrManager: false
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    })
  },
  created() {
    this.$store.commit('loader/showLoader', false);
    this.isAdminOrManager = this.currentUserDict.role === ROLE.ADMIN || this.currentUserDict.role === ROLE.MANAGER;
  },
  methods: {
    reloadScheduleReport() {
      this.$refs.staffScheduleReport.fetchStaffScheduleRecord(true);
      if (this.$refs.staffScheduleReport.tab === 'scheduleDetail') {
        this.$refs.staffScheduleReport.fetchScheduleDetail();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.staff-management {
  min-width: 1170px;
  width: 1170px;
  padding: 50px;
}

.upload-staff-schedule {
  width: 238px;
  flex: 0 0 238px;
  margin-right: 40px;
}

.staff-schedule-report,.staff-messaging-setting {
  flex: 1 1 auto;
}

.offline-auto-reply {
  flex: 0 0 607px;
  width: 607px;
  margin-right: 40px;
}
</style>
